import { Avatar } from '@mantine/core';

import { I_IconSetting } from '@/components/WidgetSetting/form-context';
import { CHATBOT_AVATAR_ARRAY } from '@/components/WidgetSetting/FormData/ChatbotAvatar';

import classes from './chatbotAvatar.module.css';

interface Props {
  avatar?: I_IconSetting;
}

const ChatbotAvatar = ({ avatar }: Props) => {
  if (!avatar) return <Avatar />;

  const CustomAvatar = CHATBOT_AVATAR_ARRAY[avatar?.index || 0];
  return (
    <Avatar size="sm" radius="xl" src={avatar?.type === 'custom' ? avatar.url : ''}>
      <span className={`${classes.avatar} ${classes.robotAvatar}`}>
        {/* <IconMessageChatbot size={20} /> */}
        <span className="scale-75">
          <CustomAvatar />
        </span>
      </span>
    </Avatar>
  );
};

export default ChatbotAvatar;
